"use strict";
var import_vitest = require("vitest");
var import_useInitializeOneRouter = require("./useInitializeOneRouter");
var probe = import_vitest.vi.hoisted(function() {
  return {
    navigationRef: {
      current: null
    },
    routerNavigationRef: null,
    initialize: import_vitest.vi.fn(function(_context, navigationRef) {
      probe.routerNavigationRef = navigationRef;
    })
  };
});
import_vitest.vi.hoisted(function() {
  Object.defineProperty(globalThis, "window", {
    configurable: true,
    value: {}
  });
});
import_vitest.vi.mock("@react-navigation/core", function() {
  return {
    useNavigationContainerRef: function() {
      return probe.navigationRef;
    }
  };
});
import_vitest.vi.mock("../useLoader", function() {
  return {
    resetLoaderState: import_vitest.vi.fn()
  };
});
import_vitest.vi.mock("./router", function() {
  return {
    initialize: probe.initialize,
    get navigationRef() {
      return probe.routerNavigationRef;
    },
    routeNode: null,
    rootComponent: null,
    initialState: void 0
  };
});
import_vitest.vi.mock("./linkingConfig", function() {
  return {
    ensureBaseLinkingConfig: import_vitest.vi.fn(),
    getSSRInitialState: import_vitest.vi.fn()
  };
});
(0, import_vitest.beforeEach)(function() {
  probe.initialize.mockClear();
});
(0, import_vitest.test)("initializes a fresh navigation root with its current location", function() {
  var context = Object.assign(function routeContext(_id) {
    throw new Error("route context is not evaluated by this probe");
  }, {
    keys: function() {
      return [];
    },
    resolve: function(id) {
      return id;
    },
    id: "preview-lifecycle-probe"
  });
  var firstRef = {
    current: null
  };
  probe.navigationRef = firstRef;
  (0, import_useInitializeOneRouter.useInitializeOneRouter)(context, new URL("https://preview.test/"));
  var nextRef = {
    current: null
  };
  var nextLocation = new URL("https://preview.test/home/feed");
  probe.navigationRef = nextRef;
  (0, import_useInitializeOneRouter.useInitializeOneRouter)(context, nextLocation);
  (0, import_vitest.expect)(probe.initialize).toHaveBeenLastCalledWith(context, nextRef, nextLocation, void 0);
});
//# sourceMappingURL=useInitializeOneRouter.preview-lifecycle.test.js.map
